import ensurePath from 'redux/ensurePath'
import immerize from '../immerize'

const initialState = {
  status: '',
  error: null,

  tours_today: 0,
  history: {
    byid: {},
    list: [],
    count: 0,
    total: 0,
    currentPage: 1,
    itemPerPage: 10,
    pageCount: 1,
  },
  typeahead: {
    staffId: [],
    device: [],
    name: [],
    zone: [],
  },
  log: null,
  print: {
    byid: {},
    status: 'pending',
  },
  statistics: {
    status: 'pending',
    data: null,
  },
}

function reducer(state = initialState, action) {
  let data
  switch (action.type) {
    case 'CLEAR_STORE':
      state = initialState
      break
    case 'TOURS_STATISTICS_COUNT':
      state.tours_today = action.payload.data
      break
    case 'TOURS_FILTERED_HISTORY_FULFILLED':
    case 'TOURS_HISTORY_FULFILLED':
      tourHistory(state, action.payload.data)
      break
    case 'TOURS_HISTORY_ITEMPERPAGE':
      tourHistoryPaginationItemPerPage(state, action.payload.count)
      break
    case 'TOURS_HISTORY_CURRPAGE':
      ensurePath(state, ['history'])
      data = action.payload.index
      state.history.currentPage = data
      break
    case 'TOURS_TYPEAHEAD_FULFILLED':
      state = tourTypeahead(state, action.payload.data)
      break
    case 'TOURS_HISTORY_CLEAR':
      ensurePath(state, ['history'])
      state.history.byid = {}
      state.history.list = []
      state.history.count = 0
      state.history.total = 0
      state.history.currentPage = 1
      state.history.pageCount = 1
      break
    case 'TOURS_LOG_FULFILLED':
      ensurePath(state, ['log'])
      data = action.payload.data
      state.log = data
      break
    case 'TOURS_LOG_CLEAR':
      ensurePath(state, ['log'])
      state.log = null
      break
    case 'TOURS_SET_PICTURE':
      updateDefaultPicture(state, action.payload.id, action.payload.idx)
      break
    case 'TOURS_PRINT_PENDING':
      data = action.payload.status

      ensurePath(state, ['print'])
      state.print.byid = {}
      state.print.list = []
      state.print.status = 'pending'
      break
    case 'TOURS_PRINT_FULFILLED':
      tourPrint(state, action.payload.data)
      break
    case 'TOURS_STATISTICS_PENDING':
      ensurePath(state, ['statistics'])
      state.statistics.status = 'pending'
      state.statistics.data = null
      break
    case 'TOURS_STATISTICS_FULFILLED':
      computeStatistics(state, action.payload.response)
      break
    case 'TOURS_STATISTICS_REJECTED':
      state = {
        ...state,
        statistics: {
          ...state.statistics,
          status: 'rejected',
          data: null,
        },
      }
      break
    default:
      return state
  }
  return state
}

function tourHistory(state, data) {
  const history = ensurePath(state, ['history'])
  const byid = ensurePath(state, ['history', 'byid'])

  history.list = history.list ?? []
  history.total = history.total ?? 0
  if (history.list.length < 1 || history.total !== data.total) {
    history.list = new Array(data.total).fill(-1)
  }
  history.list.splice(data.skip, data.list.length, ...data.list)

  Object.keys(data.data).forEach((key) => {
    byid[key] = data.data[key]
  })

  history.itemPerPage = history.itemPerPage ?? 10
  let pageCount = Math.ceil(data.total / history.itemPerPage)
  if (pageCount < 1) {
    pageCount = 1
  }
  history.total = data.total
  history.pageCount = pageCount
  history.count = history.list.length
}

function tourHistoryPaginationItemPerPage(state, count) {
  const history = ensurePath(state, ['history'])
  let pageCount = Math.ceil(history.total / count)
  if (pageCount < 1) {
    pageCount = 1
  }
  history.itemPerPage = count
  history.pageCount = pageCount
  history.currentPage = 1
}

function tourTypeahead(state, data) {
  let { typeahead, ..._state } = state
  typeahead = data
  _state = {
    ..._state,
    typeahead: typeahead,
  }
  return _state
}

function tourPrint(state, data) {
  const byid = ensurePath(state, ['print', 'byid'])

  data.forEach((e) => {
    byid[e.id] = e
  })
  state.print.status = 'done'
}

function updateDefaultPicture(state, id, idx) {
  const byid = ensurePath(state, ['history', 'byid'])

  byid[id] = byid[id] ?? {}
  byid[id].useDefault = byid[id].useDefault ?? {}
  byid[id].useDefault[idx] = true
}

function computeStatistics(state, data) {
  const statistics = ensurePath(state, ['statistics'])
  const stat = {
    pointIds: [],
  }

  data.forEach((t) => {
    // console.log(t);
    if (t.points.length < 1) {
      return
    }

    const points = {}

    // record and remove duplicates
    if (t.points.length > t.count) {
      const _points = []
      t.points.forEach((p) => {
        // console.log(p);
        if (!points[p.serialNumber]) {
          points[p.serialNumber] = {
            ori: p,
            dup: [],
          }
          _points.push(p)
        } else {
          points[p.serialNumber].dup.push(p)
          stat.pointIds.push(p.id)
        }
      })
      t.points = _points
    }

    const ts = new Date(t.startTimestamp)
    const year = 'year_' + ts.getFullYear()
    const month = 'month_' + ts.getMonth()

    if (!stat[year]) {
      stat[year] = {
        [month]: {
          [t.section]: {
            color: t.color,
            points: t.count,
            rounds: 1,
            expected: t.count,
            clocked: 0,
          },
        },
      }
      t.points.forEach((p) => {
        if (!stat[year][month][t.section][p.name]) {
          if (p.isVisited) {
            stat[year][month][t.section][p.name] = {
              count: 1,
            }
            stat[year][month][t.section].clocked += 1
          }
        } else {
          if (p.isVisited) {
            stat[year][month][t.section][p.name] = {
              count: 1,
            }
            stat[year][month][t.section][p.name].count += 1
          }
        }
      })
      return
    }

    const statYear = stat[year]
    if (!statYear[month]) {
      statYear[month] = {
        [t.section]: {
          color: t.color,
          points: t.count,
          rounds: 1,
          expected: t.count,
          clocked: 0,
        },
      }
      t.points.forEach((p) => {
        if (!stat[year][month][t.section][p.name]) {
          if (p.isVisited) {
            stat[year][month][t.section][p.name] = {
              count: 1,
            }
            stat[year][month][t.section].clocked += 1
          }
        } else {
          if (p.isVisited) {
            stat[year][month][t.section].clocked += 1
            stat[year][month][t.section][p.name].count += 1
          }
        }
      })
      return
    }

    const statMonth = stat[year][month]
    if (!statMonth[t.section]) {
      statMonth[t.section] = {
        color: t.color,
        points: t.count,
        rounds: 1,
        expected: t.count,
        clocked: 0,
      }
      t.points.forEach((p) => {
        if (!stat[year][month][t.section][p.name]) {
          if (p.isVisited) {
            stat[year][month][t.section].clocked += 1
            stat[year][month][t.section][p.name] = {
              count: 1,
            }
          }
        } else {
          if (p.isVisited) {
            stat[year][month][t.section].clocked += 1
            stat[year][month][t.section][p.name].count += 1
          }
        }
      })
      return
    }

    stat[year][month][t.section].rounds += 1
    stat[year][month][t.section].expected += t.count
    // stat[year][month][t.section].clocked += t.points.length;
    t.points.forEach((p) => {
      if (!stat[year][month][t.section][p.name]) {
        if (p.isVisited) {
          stat[year][month][t.section].clocked += 1
          stat[year][month][t.section][p.name] = {
            count: 1,
          }
        }
      } else {
        if (p.isVisited) {
          stat[year][month][t.section].clocked += 1
          stat[year][month][t.section][p.name].count += 1
        }
      }
    })
  })

  statistics.status = 'fulfilled'
  statistics.data = stat
}

export default immerize(reducer)
